export default __webpack_public_path__ + "static/david-408e0e3125584768e47712bf583284d8.png";